import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { Config } from '../common/config';

@Injectable({
	providedIn: 'root'
})
export class SharedService {
	public baseURL: any;

	constructor(private readonly http: HttpClient) {
		this.baseURL = environment.INNOVATE_API_V2;
	}

	public getProfilingQuestions(pid: any, supCode: number) {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.get(environment.ROUTER_API + 'wrapper/getQualifications/' + supCode + '/' + pid, { params: { isRouter: true } });
		}
		return this.http.get(environment.newBEHost + 'router/getQualifications/' + supCode + '/' + pid, { params: { isRouter: false } });
	}

	public setProfilingQuestions(pid: any, payload: any, supCode: number) {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.post(environment.ROUTER_API + 'wrapper/setQualifications/' + supCode + '/' + pid, this.commonEncryptionMethod(payload));
		}
		return this.http.post(environment.newBEHost + 'router/setQualifications/' + supCode + '/' + pid, payload);
	}

	public personaliseModelInventroy(pid: any, payload: any, supCode: number) {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.post(environment.ROUTER_API + 'wrapper/' + supCode + '/' + pid + '/surveys', this.commonEncryptionMethod(payload));
		}
		return this.http.post(environment.newBEHost + 'router/respondent/' + supCode + '/' + pid + '/surveys', payload);
	}

	public getRDToken(obj: any) {
		return this.http.get(environment.sampleChainApiUrl + 'get_token/' + environment.sampleChain.secretKey + '?rt_sr_pd=' + obj.id);
	}

	public getRDDetails(obj: any) {
		const url = environment.sampleChainApiUrl + 'search/' + environment.sampleChain.privateKey + '?sy_nr=' + obj.surveyID + '&rt_sr_pd=' + obj.id + '&coordinates=1';
		return this.http.get(url, { headers: new HttpHeaders({ 'token': obj.token, 'Content-Type': 'application/json' }) });
	}

	public getZipcodeData(data: any, supCode: number) {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.post(environment.ROUTER_API + supCode + '/getZipMasterData', this.commonEncryptionMethod(data));
		}
		return this.http.post(environment.surveyFlow_Backend + 'survey/getZipMasterData', data);
	}

	public checkZipcodeValidation(country: string, zipcode: string, supCode: number) {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.get(environment.ROUTER_API + 'validateZipcode/' + supCode + '/' + country +'/' + zipcode);
		}
		return this.http.get(environment.newBEHost + 'router/validateZipcode/' + supCode + '/' + country + '/' + zipcode);
	}

	public addUpdatePanelistProfiling(pid: any, payload: any, supCode: number) {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.post(environment.ROUTER_API + 'addUpdatePanelistProfile/'+ supCode + '/' + pid, this.commonEncryptionMethod(payload));
		}
		return this.http.post(environment.newBEHost + 'router/addUpdatePanelistProfile/' + supCode + '/' + pid, payload);
	}

	public getSuplierByCondition(supCode: any) {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.post(environment.ROUTER_API + supCode +'/getLocation',{});
		}
		return this.http.get(environment.INNOVATE_API + 'getSuplierByCondition/' + supCode);
	}

	public getGeoLocation(ip:any,supCode: any) {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.post(environment.ROUTER_API + supCode +'/getLocation',{});
		}
		return this.http.post(environment.INNOVATE_API + 'getLocationRouter', ip);
	}

	public commonDecryptionMethod(obj: any) {
		if (Config.ROUTER_API_ENABLED) {
			return JSON.parse(CryptoJS.AES.decrypt(obj.data, environment.secretKeyToEncDcryPayload).toString(CryptoJS.enc.Utf8));
		}
		return JSON.parse(CryptoJS.AES.decrypt(obj.data, environment.secretKeyToEncDcryPayload).toString(CryptoJS.enc.Utf8))
	}

	public getUserIp() {
		if (Config.ROUTER_API_ENABLED) {
			return this.http.get(environment.ROUTER_API + 'wrapper/panelists/getUserIpForRouter');
		}
		return this.http.get(environment.pointClubDomain + 'panelists/getUserIpForRouter');
	}

	public commonEncryptionMethod(obj:any){
        return {
            data: CryptoJS.AES.encrypt(JSON.stringify(obj), environment.secretKeyToEncDcryPayload).toString()
        }
    }
}
